import React, { useEffect, useState } from 'react';
import { BranchesOutlined, PlusOutlined } from '@ant-design/icons';
import { SKUSpecification, SKUWrapper } from '@/models/sku';
import { List } from 'antd';
import Price from '@/components/Price';
import { playSound } from '@/utils/sound';
import Modal from '@/components/Modal';
import PosButton from '@/components/PosButton';

type Props = {
  specifications: SKUWrapper['specifications'];
  onCancel: () => void;
  onSelect: (specification: Partial<SKUSpecification>) => void;
};

const SpecificationModal: React.FC<Props> = ({ specifications, onCancel, onSelect }: Props) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (specifications) {
      if (specifications.length > 1) {
        playSound('click_light');
        setOpen(true);
      } else {
        onSelect(specifications[0]);
      }
    }
  }, [specifications]);

  const close = () => {
    setOpen(false);
  };

  return (
    <Modal
      title={
        <>
          <BranchesOutlined /> 选择规格
        </>
      }
      footer={
        <>
          <PosButton size={'large'} onClick={close}>
            取消
          </PosButton>
        </>
      }
      open={open}
      onCancel={close}
      afterClose={onCancel}>
      {specifications && (
        <List
          size="small"
          bordered
          dataSource={specifications}
          renderItem={item => (
            <List.Item
              actions={[
                <PosButton
                  key={'select'}
                  danger
                  size={'large'}
                  onClick={() => {
                    onSelect(item);
                    close();
                  }}
                  icon={<PlusOutlined />}
                  disabled={item.stock <= 0}>
                  选择
                </PosButton>,
              ]}>
              <List.Item.Meta title={item.name} description={`库存: ${item.stock}`} />
              <div>
                <span>
                  售价: <Price value={item.price} />
                </span>
              </div>
            </List.Item>
          )}
        />
      )}
    </Modal>
  );
};

export default SpecificationModal;
